<template>
    <div id="loaderdash" v-if="display">
        <section id="logo-loader">
            <SaasIcon icon="svgLogoSellsyCloud" width="96" height="96" />
        </section>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
    },
    props: {
        display: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
